export const SliderDurationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="227.12"
    height="24.936"
    viewBox="0 0 227.12 24.936"
  >
    <defs>
      <clipPath id="qkez5wxb5a">
        <path
          data-name="Rectangle 7"
          transform="translate(68.939 -76.878)"
          stroke="#707070"
          fill="#707070"
          d="M0 0h165.948v10.28H0z"
        ></path>
      </clipPath>
    </defs>
    <g data-name="frise fond" opacity=".1">
      <g data-name="Groupe 156">
        <g data-name="Groupe 145">
          <path
            data-name="Tracé 117"
            d="M0 0v16.05a2.154 2.154 0 0 0 2.154 2.15h8.725a2.154 2.154 0 0 0 2.155-2.154V0"
            fill="#707070"
            transform="translate(61.016)"
          ></path>
        </g>
        <g data-name="Groupe 152" opacity=".29">
          <g data-name="Groupe 151">
            <g
              data-name="Groupe 150"
              clipPath="url(#qkez5wxb5a)"
              transform="translate(-7.767 79.016)"
            >
              <g data-name="Groupe 149">
                <path
                  data-name="Tracé 118"
                  d="M0 0h145.669"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeWidth="2.28px"
                  stroke="#707070"
                  fill="#707070"
                  transform="translate(79.079 -68.738)"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g data-name="Groupe 154">
        <path
          data-name="Tracé 120"
          d="m0 0-5.359.306 4.235 4.368L3.008 0z"
          fill="#707070"
          transform="translate(68.906 16.912)"
        ></path>
      </g>
      <g data-name="Groupe 155">
        <path
          data-name="Tracé 121"
          d="M0 0h64.391"
          strokeLinecap="round"
          strokeWidth="2.28px"
          stroke="#707070"
          fill="#707070"
          transform="translate(1.14 10.278)"
        ></path>
      </g>
      <text
        data-name="30 J."
        transform="translate(1.233 22.396)"
        fontSize="10px"
        fontFamily="ArialMT,Arial"
        fill="#707070"
      >
        <tspan x="0" y="0">
          30 J.
        </tspan>
      </text>
      <text
        data-name="60 J."
        transform="translate(40.631 22.936)"
        fontSize="10px"
        fontFamily="ArialMT,Arial"
        fill="#707070"
      >
        <tspan x="0" y="0">
          60 J.
        </tspan>
      </text>
      <text
        data-name="90 J."
        transform="translate(80.03 22.936)"
        fontSize="10px"
        fontFamily="ArialMT,Arial"
        fill="#707070"
      >
        <tspan x="0" y="0">
          90 J.
        </tspan>
      </text>
      <text
        data-name="120 J."
        transform="translate(117.946 22.936)"
        fontSize="10px"
        fontFamily="ArialMT,Arial"
        fill="#707070"
      >
        <tspan x="0" y="0">
          120 J.
        </tspan>
      </text>
      <text
        data-name="150 J."
        transform="translate(157.481 22.936)"
        fontSize="10px"
        fontFamily="ArialMT,Arial"
        fill="#707070"
      >
        <tspan x="0" y="0">
          150 J.
        </tspan>
      </text>
      <text
        data-name="180 J."
        transform="translate(196.477 22.936)"
        fontSize="10px"
        fontFamily="ArialMT,Arial"
        fill="#707070"
      >
        <tspan x="0" y="0">
          180 J.
        </tspan>
      </text>
    </g>
  </svg>
);
